import moment from "moment";
import {isEmpty} from "@/util/Helpers";
import {INVALID_DATE} from "@/util/EnumUtil";

export const dateToEpoch = (value) => {
    if (!isEmpty(value) && value !== INVALID_DATE) {
        return moment(value, 'DD/MM/YYYY').valueOf()
    }
    return null
}
export const dateToEpochHmGennhshs = (value) => {
    if (!isEmpty(value) && value !== INVALID_DATE) {
        let date = moment(value, 'DD/MM/YYYY').add(5, 'hours').valueOf()
        return date
    }
    return null
}
export const epochToDate2 = (value) => {
    if (!isEmpty(value) && value !== INVALID_DATE) {
        let val = moment.unix(value / 1000)
        return val.format("DD/MM/YYYY")
    }
    return null
}
export const epochToDate = (value) => {
    if (!isEmpty(value) && value !== INVALID_DATE) {
        let val = moment(value)
        return val.format('DD/MM/YYYY')
    }
    return null
}
export const epochToDateTime = (value) => {
    if (!isEmpty(value) && value !== INVALID_DATE) {
        let val = moment(value)
        return val.format('DD/MM/YYYY HH:mm')
    }
    return null
}

export const formatDateGRDefault = (value) => {
    if (!isEmpty(value) && value !== '' && value !== INVALID_DATE) {
        if (moment(value, 'YYYY-MM-DD', true).isValid()) {
            let epochDate = moment(value, 'YYYY-MM-DD').valueOf()
            return moment(epochDate).format('DD/MM/YYYY');
        }  if (moment(value, 'DD/MM/YYYY HH:mm', true).isValid()) {
            let epochDate = moment(value, 'YYYY-MM-DD HH:mm').valueOf()
            return moment(epochDate).format('DD/MM/YYYY HH:mm');
        } else {
            let epochDate = moment(value, 'DD/MM/YYYY').valueOf()
            return moment(epochDate).format('DD/MM/YYYY');
        }
    }
}

export const formatDateUTCDefault = (value) => {
    if (!isEmpty(value) && value !== '' && value !== INVALID_DATE) {
        if (moment(value, 'YYYY-MM-DD', true).isValid()) {
            let epochDate = moment(value, 'YYYY-MM-DD').valueOf()
            return moment(epochDate).format('YYYY-MM-DD');
        } else {
            let epochDate = moment(value, 'DD/MM/YYYY').valueOf()
            return moment(epochDate).format('YYYY-MM-DD');
        }
    }
}
export const formatDateWithFormat = (value) => {
    if (!isEmpty(value) && value !== '' && value !== INVALID_DATE) {
        if (moment(value, 'YYYY-MM-DD', true).isValid()) {
            let epochDate = moment(value, 'YYYY-MM-DD').valueOf()
            return moment(epochDate).format('DD/MM/YYYY');
        } else if (moment(value, 'DD/MM/YYYY', true).isValid()) {
            let epochDate = moment(value, 'DD/MM/YYYY').valueOf()
            return moment(epochDate).format('YYYY-MM-DD');
        } else if (moment(value, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
            let epochDate = moment(value, 'YYYY-MM-DD HH:mm:ss').valueOf()
            return moment(epochDate).format('DD/MM/YYYY HH:mm:ss');
        } else {
            let epochDate = moment(value, 'DD/MM/YYYY HH:mm:ss').valueOf()
            return moment(epochDate).format('DD/MM/YYYY HH:mm:ss');
        }
    }
}
export const formatDateTime = (value) => {
    if (value != null && value !== '' && value !== undefined && value.toString() !== 'Invalid Date') {
        let myDate = moment(value);
        return moment(myDate).format('DD/MM/YYYY HH:mm:ss');
    } else {
        return null;
    }
}